define('constants/howDidYouHearAboutUsEnumerations',[], function() {
    return {
        billboard: "Billboard",
        blogOrArticle: "Blog or Article",
        currentCustomer: "Current Customer",
        directMail: "Direct Mail",
        displayAd: "Display Ad",
        email: "Email",
        eventOrConference: "Event or Conference",
        podcast: "Podcast",
        printAd: "Print Ad",
        radio: "Radio",
        searchEngine: "Search Engine",
        socialMedia: "Social Media",
        television: "Television",
        other: "Other"
    };
});

